import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteAllowedRule implements IPasteRule {
  private static _instance = new PasteAllowedRule();
  private constructor() {}
  public static get INSTANCE(): PasteAllowedRule {
    return this._instance;
  }
  canPaste(_pasteLocation: PasteLocation, _pasteField: SerializedFieldContext): boolean {
    return true;
  }
}
